import React from "react";
import CardBasic from "../ui/Card.jsx";
import PageTitle from "../ui/PageTitle.jsx";
import MenuItem from "./MenuItem.jsx";

const SettingsIndex = ({ isAdmin }) => {
  const showAdminOnly = isAdmin === 'true';

  return (
    <div>
      <PageTitle pageTitle="Einstellungen" />

      <h5>Allgemein</h5>
      <CardBasic>
        <div className="row">
          <MenuItem
            title="Dashboard"
            subtitle={`Anpassen der Inhalte und Layouts des Dashboards.`}
            icon={"RiDashboardHorizontalLine"}
            menu="settings/dashboard"
          />
          <MenuItem
            title="Dateien"
            subtitle="Verwaltung von Dateien für den E-Mail-Versand."
            icon={"RiFolder6Line"}
            menu="settings/files"
          />
          <MenuItem
            title="Externe Seiten"
            subtitle="Hinzufügen und Bearbeiten von externen Seiten."
            icon={"RiGlobalLine"}
            menu="settings/extern"
          />
          <MenuItem
            title="Kalendar"
            subtitle="Einstellungen für interne und externe Kalender."
            icon={"RiCalendarLine"}
            menu="settings/calendar"
          />
          <MenuItem
            title="Logos"
            subtitle="Hochladen und Verwalten von Firmenlogos."
            icon={"RiImage2Line"}
            menu="settings/logos"
          />
          <MenuItem
            title="Stammdaten"
            subtitle="Anpassen und Verwalten der Stammdaten."
            icon={"RiContactsBook2Line"}
            menu="settings/basedata"
          />
          <MenuItem
            title="Voreinstellungen"
            subtitle="Festlegen von Voreinstellungen für das System."
            icon={"RiSettings3Line"}
            menu="settings/presets"
          />
          <MenuItem
            title="Firmen"
            subtitle="Weitere Firmen anlegen und zwischen ihnen wechseln."
            icon={"RiBuildingLine"}
            menu="settings/companies"
          />
          <MenuItem
            title="Integrationen"
            subtitle="Anbindung und Konfiguration externer Dienste."
            icon={"RiApps2Line"}
            menu="settings/integrations"
          />
        </div>
      </CardBasic>

      <h5>Schriftliches</h5>
      <CardBasic>
        <div className="row">
          <MenuItem
            title="Dokumente"
            subtitle="Vorlagen für Briefköpfe und Texte verwalten."
            icon={"RiFileLine"}
            menu="settings/documents"
          />
          <MenuItem
            title="E-Mail"
            subtitle="Verwalten von E-Mail-Accounts und Signaturen."
            icon={"RiMailLine"}
            menu="settings/email"
          />
          <MenuItem
            title="Mahnungen"
            subtitle="Texte und Stufen für Mahnungen konfigurieren."
            icon={"RiFileList2Line"}
            menu="settings/reminder"
          />
          <MenuItem
            title="Nummernkreise"
            subtitle="Festlegen von Nummernkreisen für Angebote und Rechnungen."
            icon={"RiListUnordered"}
            menu="settings/numbercircle"
          />
          <MenuItem
            title="Gutscheine"
            subtitle="Erstellen und Verwalten von Gutscheinvorlagen."
            icon={"RiBankCard2Line"}
            menu="settings/vouchers"
          />
        </div>
      </CardBasic>

      <h5>Vorlagen</h5>
      <CardBasic>
        <div className="row">
          <MenuItem
            title="Formulare"
            subtitle="Erstellen und Verwalten von Formularen."
            icon={"RiLayoutBottomLine"}
            menu="forms"
          />
          <MenuItem
            title="Unterschriftsdokumente"
            subtitle="Vorlagen für signierbare Dokumente (Übergabeprotokolle, Einwilligungen)."
            icon={"RiFileCheckLine"}
            menu="signaturedocuments"
          />
          <MenuItem
            title="Eigene Schriftart"
            subtitle="Eigene Schrift für Formulare und Newsletter hochladen."
            icon={"RiText"}
            menu="customfonts"
          />
          <MenuItem
            title="Fragebogen"
            subtitle="Erstellen und Verwalten von Fragebögen."
            icon={"RiQuestionAnswerLine"}
            menu="questionaire"
          />
          <MenuItem
            title="Notizvorlagen"
            subtitle="Erstellen und Verwalten von Notizvorlagen."
            icon={"RiArticleLine"}
            menu="notestemplates"
          />
          <MenuItem
            title="Textvorlagen"
            subtitle="Erstellen und Verwalten von Textvorlagen."
            icon={"RiText"}
            menu="texttemplates"
          />
          <MenuItem
            title="Verträge"
            subtitle="Erstellen und Verwalten von Vertragsvorlagen."
            icon={"RiEditLine"}
            menu="contracts"
          />
          <MenuItem
            title="Workflow"
            subtitle="Erstellen und Verwalten von Workflows."
            icon={"RiShareLine"}
            menu="workflows"
          />
        </div>
      </CardBasic>

      <h5>Sonstiges</h5>
      <CardBasic>
        <div className="row">
          <MenuItem
            title="Diverses"
            subtitle="Sonstige Einstellungen und Konfigurationen."
            icon={"RiMoreLine"}
            menu="settings/diverse"
          />
          <MenuItem
            title="Status"
            subtitle="Anpassen von Status för Jobs und Hochzeiten."
            icon={"RiLayoutTop2Line"}
            menu="settings/status"
          />
          <MenuItem
            title="Kundenportal"
            subtitle="Anpassen des Kundenportals."
            icon={"RiContactsLine"}
            menu="settings/customer_portal"
          />
          <MenuItem
            title="Zusatzfelder"
            subtitle="Benutzerdefinierte Felder für Kontakte, Jobs und Hochzeiten."
            icon={"RiFileList3Line"}
            menu="settings/customFields"
          />
          <MenuItem
            title="Menü"
            subtitle="Anpassen des Hauptmenüs."
            icon={"RiMenu2Line"}
            menu="settings/menu_config"
          />
        </div>
      </CardBasic>
    </div>
  );
};

export default SettingsIndex;
